import React, { useState } from "react";
import { useSelector } from "react-redux";
import ActivitiesDashboard from "./activities/ActivitiesDashboard";
import NightLifeDashboard from "./nightLife/NightLifeDashboard";
import RestaurantDashboard from "./restaurant/RestaurantDashboard";
import HotelDashboard from "./users/HotelDashboard";
import AdminDashboard from "./restaurant/AdminDashboard";


const DashboardAction = () => {
  const { current } = useSelector((state) => state.user);
  const [userRole] = useState(current?.user_type);
  
  const renderData = () => {
    switch (userRole) {
      case "Activity":
        return <ActivitiesDashboard />;
      case "Nightlife":
        return <NightLifeDashboard />;
      case "Restaurant":
        return <RestaurantDashboard />;
      case "Hotel":
        return <HotelDashboard />;
      case "Licensee":
        return <HotelDashboard />;
      case "Promoter":
        return <HotelDashboard />;
      case "Advertiser":
        return <HotelDashboard />;
      case "Designer":
        return <HotelDashboard />;
      case "Designer":
          return <HotelDashboard />;
      case "Generic":
          return <HotelDashboard />;
      default:
        return <AdminDashboard />;
    }
  };
  return (
    <>
      {console.log("current", current)}
      {renderData()}
    </>
  );
};

export default DashboardAction;
